import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
  DropdownMenuLabel, DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'
import { CalendarDays, CalendarRange, LogOut, UserCog } from 'lucide-react'
import { CalendarFeedDialog } from '@/components/CalendarFeedDialog'

// Small avatar with the user's initial, gated behind a dropdown that
// surfaces the name and the sign-out action. Replaces the standalone
// sign-out icon so the header stays uncluttered.
export function UserMenu() {
  const { user, profile, signOut } = useAuth()
  const navigate = useNavigate()
  const [feedOpen, setFeedOpen] = useState(false)
  const name = profile?.nombre ?? user?.email ?? 'User'
  const initial = name.slice(0, 1).toUpperCase()

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            className="w-9 h-9 rounded-full bg-muted overflow-hidden flex items-center justify-center text-sm font-semibold text-foreground hover:bg-accent transition-colors outline-none"
            aria-label="Account"
          >
            {profile?.avatar_url ? (
              <img src={profile.avatar_url} alt={name} className="w-full h-full object-cover" />
            ) : (
              initial
            )}
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-60">
          <DropdownMenuLabel className="flex flex-col gap-0.5 py-3">
            <span className="text-sm font-medium text-foreground">{name}</span>
            {user?.email && (
              <span className="text-xs text-muted-foreground truncate">{user.email}</span>
            )}
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={() => navigate('/my-agenda')}
            className="cursor-pointer"
          >
            <CalendarRange className="w-4 h-4" />
            My agenda
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => setFeedOpen(true)}
            className="cursor-pointer"
          >
            <CalendarDays className="w-4 h-4" />
            Calendar feed
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => navigate('/profile')}
            className="cursor-pointer"
          >
            <UserCog className="w-4 h-4" />
            Edit profile
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={signOut}
            className="cursor-pointer"
          >
            <LogOut className="w-4 h-4" />
            Sign out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <CalendarFeedDialog open={feedOpen} onOpenChange={setFeedOpen} />
    </>
  )
}
